export default "__VITE_ASSET__BnKESEon__"